<template lang="html">
	<div class="createDownload-main">
		<div class="createDownload-container">
			<div class="breadCrumb-container">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item>{{$t('message.download')}}</el-breadcrumb-item>
					<el-breadcrumb-item>{{$t('message.createTaskMenu')}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="body-container verifone-panel btn-table"  v-show="isTableShow">
				<template>
					<div class="table-container">
						<div class="table-main">
							<template>
								<el-table ref="multipleTableCreate" :data="createTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
									<el-table-column type="selection" width="55"></el-table-column>
									<el-table-column label="" width="50">
										<template slot-scope="scope">
											<img class="logo-icon" :src="scope.row.logo" alt="">
										</template>
									</el-table-column>
									<el-table-column label="APP" :show-overflow-tooltip="true">
										<template slot-scope="scope">{{ scope.row.name }}</template>
									</el-table-column>
                 <!-- 版本号-->
									<el-table-column :label="$t('message.version')" :show-overflow-tooltip="true" >
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.selectVersion" @change="versionSelectChange(scope)" >
                        <el-option v-for="item in scope.row.versionList" :key="item" :label="item" :value="item" >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
									<el-table-column prop="company" :label="$t('message.developer')" :show-overflow-tooltip="true"></el-table-column>
									<el-table-column prop="utime" :label="$t('message.date')" :show-overflow-tooltip="true"></el-table-column>
									<el-table-column prop="size" :label="$t('message.size')" :show-overflow-tooltip="true" width="120"></el-table-column>
								</el-table>
							</template>
						</div>

						<div class="pagination-main">
							<el-pagination  background layout="prev, pager, next" :total="totalPage*10" @current-change="changePage"></el-pagination>
						</div>

						<div class="createBtn-main">
							<div class="num-container">
								<span v-text="selectedLength"></span>
                <span> {{$t('message.appChoose')}}</span>
							</div>
							<el-button class="verifone-btn createTask" type="success" plain icon="el-icon-download" @click="createTask">{{$t('message.createTask')}}</el-button>
						</div>
					</div>
				</template>
			</div>

			<div class="body-container verifone-panel" v-show="isSelectorShow">
				<template>
				 	<div class="createSelector-container">
            <div class="createSelector-main">

							<div class="create-item">
								<div class="create-left">
									<div class="task-title title">
										<span class="required">*</span>
                    <span>{{$t('message.downloadName')}}</span>
                  </div>
								</div>
								<div class="create-right">
									<div class="taskName-container">
                    <el-input class="taskName" v-model="taskName" :placeholder="$t('message.charTip50')" maxLength="50"></el-input>
                  </div>
								</div>
							</div>

							<div class="create-item">
								<div class="create-left">
									<div class="date-title title">
                    <span>{{$t('message.downloadTime')}}</span>
                  </div>
								</div>
								<div class="create-right">
									<div class="date-selector">
                    <el-radio-group v-model="downloadRadio">
                      <el-radio :label="0">{{$t('message.nextContact')}}</el-radio>
                      <el-radio :label="1">{{$t('message.dateTime')}}</el-radio>
                    </el-radio-group>
                    <div class="date-picker-container">
                      <div class="block">
                        <el-date-picker :disabled="updateDownload" v-model="downloadDate1" @change="changeDownloadStart" :picker-options="pickerOptions1" type="date" value-format="yyyy-MM-dd" :editable="false" :placeholder="$t('message.date')"></el-date-picker>
                      </div>
                      <span class="date-split">-</span>
                      <div class="block">
                        <el-date-picker :disabled="updateDownload" v-model="downloadDate2" @change="changeDownloadEnd" :picker-options="pickerOptions2" type="date" value-format="yyyy-MM-dd" :editable="false" :placeholder="$t('message.date')"></el-date-picker>
                      </div>
                    </div><br>
                    <div class="time-selector">
                      <template>
                        <el-time-select :disabled="updateDownload" :editable="false" v-model="downloadTime1" :picker-options="{
				                  start: '00:00',
				                  step: '01:00',
				                  end: '24:00'
				                }" :placeholder="$t('message.time')"/>
                        <span class="time-split">-</span>
                        <el-time-select :disabled="updateDownload" :editable="false" v-model="downloadTime2" :picker-options="{
				                  start: '00:00',
				                  step: '01:00',
				                  end: '24:00'
				                }" :placeholder="$t('message.time')"/>
                      </template>
                    </div>
                  </div>
								</div>
							</div>

							<div class="create-item">
								<div class="create-left">
									<div class="install-title title">
                    <span>{{$t('message.installTime')}}</span>
                  </div>
								</div>
								<div class="create-right">
									<div class="install-selector">
                    <el-radio-group v-model="installRadio">
                      <el-radio :label="0">{{$t('message.installImmediately')}}</el-radio>
                      <el-radio :label="1">{{$t('message.installTime1')}}</el-radio>
                    </el-radio-group>
                    <div class="block">
                      <el-date-picker :disabled="updateInstall" v-model="installDate" :editable="false" :picker-options="pickerOptions3" type="date" value-format="yyyy-MM-dd" :placeholder="$t('message.date')"></el-date-picker>
                    </div>
                    <div class="install-time-selector">
                      <template>
                        <el-time-select :disabled="updateInstall" :editable="false" v-model="installTime1" :picker-options="{
					                start: '00:00',
					                step: '01:00',
					                end: '24:00'
					              }" :placeholder="$t('message.time')"/>
					              <span class="time-split">-</span>
                        <el-time-select :disabled="updateInstall" :editable="false" v-model="installTime2" :picker-options="{
					                start: '00:00',
					                step: '01:00',
					                end: '24:00'
					              }" :placeholder="$t('message.time')"/>
                      </template>
                    </div>
                  </div>
								</div>
							</div>

							<div class="create-item">
								<div class="create-left">
									<div class="notification-title title">
                    <span>{{$t('message.installNotify')}}</span>
                  </div>
								</div>
								<div class="create-right">
									<div class="install-selector">
                    <el-radio-group v-model="installNotification">
                      <el-radio :label="0">{{$t('message.silentInstall')}}</el-radio>
                      <el-radio :label="1">{{$t('message.askCashier')}}</el-radio>
                    </el-radio-group>
                  </div>
								</div>
							</div>

							<div class="create-item">
								<div class="create-left">
									<div class="notification-title title">
                    <span>{{$t('message.pushRange')}}</span>
                  </div>
								</div>
								<div class="create-right">
									<div class="install-selector">
                    <el-radio-group v-model="range">
                      <el-radio :label="0">{{$t('message.allTerminal')}}</el-radio>
                      <el-radio :label="1">{{$t('message.grayscale')}}</el-radio>
                    </el-radio-group>
										<el-select multiple collapse-tags filterable :disabled="updateRange" v-model="valueGroups" style="width: 305px;"
											:placeholder="$t('message.pleaseChoose')">
											<el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id"/>
										</el-select>
                  </div>
								</div>
							</div>
            </div>

            <div class="createSelector-footer">
							<div class="submit-container">
                <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="toCreateList">{{$t('message.cancel')}}</el-button>
                <el-button class="verifone-btn" type="primary" icon="el-icon-document" @click="handleSubmit">{{$t('message.submit')}}</el-button>
              </div>
            </div>
            <!--  点击按钮提醒是否下载改任务-->
            <el-dialog title="" :visible.sync="createConfirm" width="30%" :close-on-click-modal= "false" :close-on-press-escape= "false"
                       class="quit-dialog warn-dialog">
							<div class="warn-container flex-row">
								<img class="warn-icon" alt="" src="static/img/alertWarn.png">
								<span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
							</div>
							<div class="dialog-body">
								<span>{{$t('message.downloadCreate')}}</span><span>{{taskName}}</span><span>"?</span>
							</div>
              <span slot="footer" class="dialog-footer">
                <el-button class="verifone-btn" type="primary" plain @click="createConfirm = false">{{$t('message.no')}}</el-button>
                <el-button class="verifone-btn" type="primary" @click="submitCreateDownload">{{$t('message.yes')}}</el-button>
              </span>
            </el-dialog>
          </div>
				</template>
			</div>
		</div>
	</div>

</template>

<script>
export default {
	inject: ['reload'],
	data() {
		return {
		  count:0,
			isTableShow: true,
			isSelectorShow: false,
			downloadRadio: 0,
      installRadio: 0,
      installNotification: 0,
			range: 0,
			token: '',
			pageFlag: false,
      taskName: '',
      downloadDate1: '',
      downloadDate2: '',
      downloadTime1: '',
      downloadTime2: '',
      installDate: '',
      installTime1: '',
      installTime2: '',
      createConfirm: false,
			currentPage: 1,
			totalPage: 1,
			selectedApp: [],
      selectedAppResult:'',
			selectedLength: 0,
			createList: [],
			createTable: [],// App集合（仅最新）
      allVersionData: [], // APP集合（新版与旧版）
			multipleSelection: [],
			inputCheck: this.$t('message.inputCheck'),
			dateCheck: this.$t('message.dateCheck'),
			installDateCheck: this.$t('message.installDateCheck'),
			createSuccess: this.$t('message.createSuccess'),
			chooseApp: this.$t('message.chooseApp'),
      createBack: this.$t('message.createBack'),
      validDownloadTimes: this.$t('message.validDownloadTimes'),
      invalidTime: this.$t('message.invalidTime'),
      yes:this.$t('message.yes'),
      no:this.$t('message.no'),
			pickerOptions1: {
				disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
			},
			pickerOptions2: {
				disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
			},
			pickerOptions3: {
				disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
			},
			groups: [],
			valueGroups: []
		}
	},

	mounted() {
		// this.setToken();
    this.queryAppListInit(1);
  },
	computed: {
		updateDownload: function() {
			return !this.downloadRadio;
		},
		updateInstall: function() {
			return !this.installRadio;
		},
		updateRange: function() {
			return !this.range;
		},
    changeData(){
      const {taskName,downloadDate1,downloadDate2,downloadTime1,downloadTime2,installDate,installTime1,installTime2,range,installNotification,downloadRadio,installRadio}=this
      return{
        taskName,downloadDate1,downloadDate2,downloadTime1,downloadTime2,installDate,installTime1,installTime2,range,installNotification,downloadRadio,installRadio
      }
    }
	},
  watch:{
    changeData: {
      handler(oldVal, newVal) {
         if (newVal == oldVal) {
          this.count == 0;
        }else if(newVal!=oldVal){
           this.count++;
         }
      },
      deep: true

    }
  },
	methods: {
		setToken() {
			this.token = new Date().getTime();
		},
		changeDownloadStart() {
			var disabledMax = new Date(this.downloadDate1).getTime() - 3600 * 1000 * 24;
			// this.pickerOptions2 = {
			// 	disabledDate(time) {
		    //         return time.getTime() < disabledMax;
		    //     }
			// }

			// this.downloadDate2 = '';
			// this.installDate = '';
		},
		changeDownloadEnd() {
			var disabledMax = new Date(this.downloadDate1).getTime();
			// this.pickerOptions3 = {
			// 	disabledDate(time) {
		    //         return time.getTime() < disabledMax;
		    //     }
			// }

			// this.installDate = '';
		},

		handleSubmit() {
			let downloadCheckStart = new Date(this.downloadDate1).getTime();
			let downloadCheckEnd = new Date(this.downloadDate2).getTime();
			let installCheck = new Date(this.installDate).getTime();
			let downloadtime1 = this.downloadTime1;
			let downloadtime2 = this.downloadTime2;
			let installtime1 = this.installTime1;
			let installtime2 = this.installTime2;
			var downloadTime1 = parseInt(downloadtime1);
			var downloadTime2 = parseInt(downloadtime2);
			var installTime1 = parseInt(installtime1);
      var installTime2 = parseInt(installtime2);

			// 任务名称校验
			if(!this.taskName || this.taskName == '') {
				this.$message({
					type: "error",
					message: this.inputCheck,
					duration:'3000',
				});
				return;
			}

      // 下载时间校验
			if(this.downloadRadio == 1) {
				if(this.downloadDate1 == '' || this.downloadDate2 == '' || this.downloadTime1 == '' || this.downloadTime2 == '') {
					this.$message({
						type: "error",
						message: this.dateCheck,
						duration:'3000',
					});
					return;
				}
				if(downloadCheckEnd < downloadCheckStart) {
					this.$message({
						type: "error",
						message: this.validDownloadTimes,
						duration:'3000',
					});
					return;
				}
				if(downloadCheckEnd == downloadCheckStart && downloadTime1==downloadTime2 ){
          this.$message({
            type: "error",
            message: this.invalidTime,
            duration:'3000',
          });
          return;
        }
			}

      // 安装时间校验
			if(this.installRadio == 1) {
				if(this.installDate == '' || this.installTime1 == '' || this.installTime2 == '') {
					this.$message({
						type: "error",
						message: this.installDateCheck,
						duration:'3000',
					});
					return;
				}
        if(installTime1 == installTime2){
          this.$message({
            type: "error",
            message: this.invalidTime,
            duration:'3000',
          });
          return;
        }
			}

			if(this.downloadRadio == 1 && this.installRadio == 1) {
				if(installCheck < downloadCheckStart) {
					this.$message({
						type: "error",
						message: 'Invalid install date',
						duration:'3000',
					});
					return;
				}
			}

			this.createConfirm = true;
		},

     /*返回*/
		toCreateList() {
      if(this.count>0) {
      this.$confirm(this.$i18n.t('message.createBack'), this.warn, {
        confirmButtonText: this.$i18n.t('message.yes'),
        cancelButtonText: this.$i18n.t('message.no'),
        type: 'warning'
      }).then(() => {
        this.isSelectorShow = false;
        this.isTableShow = false;
        this.reload();
      })
      }else{
        this.isSelectorShow = false;
        this.isTableShow = true;
        /*this.reload();*/
      }
    },
		createTask() {
			if(this.selectedLength === 0) { //XXXXX
				this.$message({
					type: "error",
					message: this.chooseApp,
					duration:'3000',
				});
				return;
			}
      this.allVersionData
			this.isTableShow = false;
			this.isSelectorShow = true;
			this.downloadRadio = 0;
            this.installRadio = 0;
            this.installNotification = 0;
            this.taskName = '';
            this.downloadDate1 = '';
            this.downloadDate2 = '';
            this.downloadTime1 = '';
            this.downloadTime2 = '';
            this.installDate = '';
            this.installTime1 = '';
            this.installTime2 = '';
			this.queryGroup();
			this.setToken();


      for(let i=0; i<this.selectedApp.length; i++) {
      	for(let j=0; j<this.selectedApp[i].length; j++) {
      		if(this.selectedApp[i][j]) {
            this.selectedAppResult= this.selectedAppResult +this.selectedApp[i][j].name+"-"+this.selectedApp[i][j].version+"，"
      		}
      	}
      }
         this.selectedAppResult  = this.selectedAppResult.substring(0,this.selectedAppResult.length-1);
		},
		queryGroup() {
			this.$axios({
                method: 'get',
                url: "/marketplace/common/query/group",
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.groups = response.data.groups;
                }
            }).catch((err) => {
                console.log(err);
            });
		},
		handleSelectionChange(val) {
			let pageIndex = this.currentPage - 1,
				checkedLength = 0,
				that = this;

			if(!this.pageFlag) {
				this.multipleSelection = val;
				this.selectedApp[pageIndex] = val;
			}else {
				that.pageFlag = false;
			}

			for(let i=0; i<this.selectedApp.length; i++) {
				checkedLength += this.selectedApp[i].length;
			}

			this.selectedLength = checkedLength;
		},
		changePage(num) {
			//判断当前页面已选app列表是否为空，如为空则不需要刷新选择，pageFlag为false
			this.pageFlag = this.selectedApp[num - 1].length === 0 ? false : true ;

			this.currentPage = num;

			this.queryAppList(num);
		},
		toggleSelection(rows) {
			let that = this;

			if (rows) {
				rows.forEach(row => {
					this.createTable.forEach((item, index) => {
						if(item.id == row.id) {
							this.$refs.multipleTableCreate.toggleRowSelection(this.createTable[index], true);
						}
					});
				});
			} else {
				this.$refs.multipleTableCreate.clearSelection();
			}

		},
		queryAppList(page) {
			let that = this;
			let obj = {
                pageNum: page
            };

			this.$axios({
                method: 'post',
                url: '/marketplace/app/page',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                  this.createTable = response.data.appList;
					        this.totalPage = response.data.totalPage;



					//selected
					this.multipleSelection = this.selectedApp[page - 1];


					setTimeout(function() {
						that.toggleSelection(that.multipleSelection);
					}, 200);

                }
            }).catch((err) => {
                console.log(err);
            });
		},
		queryAppListInit(page) {
			let that = this;
			let obj = {
                pageNum: page
            };

			this.$axios({
                method: 'post',
                url: '/marketplace/app/page',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
				data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.createTable = response.data.appList;
					          that.totalPage = response.data.totalPage;
                    that.allVersionData = response.data.allAppList;

					for(let i=0; i<response.data.totalPage; i++) {
						this.selectedApp[i] = [];
					}
                }
            }).catch((err) => {
                console.log(err);
            });
		},
		submitCreateDownload() {
			let appIdList = [],
				that = this,
				obj = {
          appList: appIdList,
          taskName: this.taskName,
          downloadType: this.downloadRadio,
          installType: this.installRadio,
          downloadDateStart: this.downloadDate1,
          downloadDateEnd: this.downloadDate2,
          installDateStart: this.installDate,
          downloadTimeStart: this.downloadTime1,
          downloadTimeEnd: this.downloadTime2,
          installTimeStart: this.installTime1,
          installTimeEnd: this.installTime2,
          remindType: this.installNotification,
					releaseRangeType: this.range,
					releaseRangeList: this.valueGroups,
					token: this.token
        };

          console.log("xuanze:"+JSON.stringify(this.selectedApp));
			for(let i=0; i<this.selectedApp.length; i++) {
				for(let j=0; j<this.selectedApp[i].length; j++) {
					if(this.selectedApp[i][j]) {
						appIdList.push(this.selectedApp[i][j].id);
					}
				}
			}


			// this.multipleSelection.forEach(item => {
			// 	appIdList.push(item.id);
			// });
			this.$axios({
                method: 'post',
                url: '/marketplace/task/app/add',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    that.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.$message({
                        type: "success",
                        message: this.createSuccess,
                        duration:'3000',
                    });

					that.createConfirm = false;
					that.toggleSelection();

					that.isSelectorShow = false;
					that.isTableShow = true;

					this.reload();
					//clear sessionStorage
					// that.selectedApp.forEach(item => {
					// 	item = [];
					// });
					// that.selectedLength = 0;
					// //clear history
					// that.multipleSelection = [];
                }

            }).catch((err) => {
                console.log(err);
            });
        },
    // 版本下拉框 选中值发生变化时触发
    versionSelectChange(scope){
      var rowIndex = scope.$index;
      var row = scope.row;
      var selectVersion = row.selectVersion;
      var versionList = row.versionList;
      var packageName = row.packageName;
      var newRow;
      for(var i=0,len=this.allVersionData.length; i<len; i++){
        var data = this.allVersionData[i];
        if(data.packageName == packageName && data.version == selectVersion){
          newRow = data;
          break;
        }
      }
      newRow.selectVersion = selectVersion;
      newRow.versionList = versionList;
      this.createTable.splice(rowIndex,1,newRow);
    }
	}

}
</script>

<style scoped="scope">
.has-gutter {
	border-bottom: 1px solid #00a0e8;
}
/* .createSelector-main, .date-picker-container, .createSelector-footer { */
.date-picker-container, .createSelector-footer, .create-item {
	display: flex;
	display: -webkit-flex;
	flex-direction: row;
}
.createSelector-container, .download-date, .download-time, .selector-left, .el-radio-group,
.selector-right, .install-selector {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
}
.createSelector-container {
    padding: 30px 20px;
    /* margin-top: 20px; */
    background-color: #fff;
}
.selector-left {
    border-right: 1px solid #bbb;
}
.createSelector-main {
    width: 100%;
}
.el-radio+.el-radio {
    margin-left: 0;
}
.title {
    padding: 0 20px;
}
.el-radio {
    height: 30px;
}
.el-date-editor {
    width: 140px!important;
}
.date-split {
    height: 40px;
    line-height: 40px;
    margin: 0 10px;
}
.time-split {
    height: 40px;
    line-height: 40px;
    margin: 0 5px;
}
.download-time {
    margin-top: 40px;
}
.install-time-selector {
    margin-top: 15px;
}
.arrows-right {
	width: 25px;
	height: 25px;
	position: relative;
	bottom: -7px;
}
/* .load-selector {
	background-color: #58D56D!important;
	color: #fff!important;
	padding: 10px 15px;
	margin: 0 3px 0 20px;
	border: none;
} */
.createSelector-footer {
    justify-content: flex-end;
    margin-top: 20px;
}
.title span {
	font-size: 16px;
	font-family: 'Arial';
}
.table-container {
	margin-top: 20px;
	background-color: #fff;
	position: relative;
}
.table-main {
	padding: 20px;
}
.pagination-main {
	padding: 10px 0 30px 0!important;
}
.createBtn-main {
	display: flex;
	display: -webkit-flex;
	flex-direction: row;
	position: absolute;
	right: 20px;
	bottom: 30px;
	align-items: center;
	padding-right: 10px;
}
.load-selector {
	background-color: #58D56D!important;
	color: #fff!important;
	padding: 10px 15px;
	margin: 0 3px 0 20px;
	border: none;
}
.arrows-left {
	width: 25px;
	height: 25px;
	transform: rotate(180deg);
	position: relative;
	bottom: 0px;
	cursor: pointer;
	margin-left: 10px;
}
.num-container {
	font-size: 15px;
	color: #666;
}
.required {
    color: red;
    font-size: 30px;
    font-weight: 600;
    /* position: absolute;
    top: 10px;
    left: -20px; */
}
.taskName-container {
    position: relative;
}
.selector-left, .selector-right {
    padding: 40px;
}
.taskName {
    width: 305px;
}
.arrows-right {
    cursor: pointer;
}
.logo-icon {
	width: 36px;
	height: 36px;
}
.title-container {
	padding-left: 20px;
}
.createTask {
	width: 120px;
	margin-left: 20px;
}
.create-item {
	margin-bottom: 20px;
}
.create-left {
	width: 18vw;
	display: flex;
	display: -webkit-display;
	justify-content: flex-end;
}
.verifone-panel {
	/* margin-top: 62px; */
	margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/CreateDownload.vue